import React from 'react';

export const FormMessage = () => {
  return <div>FormMessage</div>;
};
